/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Catalogue_OfflineInputs */

const en_us2_plan_build_catalogue_offline = /** @type {(inputs: Plan_Build_Catalogue_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The catalogue isn't on this device yet. Connect once to search offline.`)
};

const pt_br2_plan_build_catalogue_offline = /** @type {(inputs: Plan_Build_Catalogue_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O catálogo ainda não foi baixado neste aparelho. Conecte-se uma vez para buscar offline.`)
};

const es_419_plan_build_catalogue_offline = /** @type {(inputs: Plan_Build_Catalogue_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El catálogo todavía no está en este dispositivo. Conéctate una vez para buscar sin conexión.`)
};

const pt_pt2_plan_build_catalogue_offline = /** @type {(inputs: Plan_Build_Catalogue_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O catálogo ainda não foi transferido para este dispositivo. Liga-te uma vez para pesquisar offline.`)
};

const fr_fr2_plan_build_catalogue_offline = /** @type {(inputs: Plan_Build_Catalogue_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le catalogue n'est pas encore sur cet appareil. Connecte-toi une fois pour chercher hors ligne.`)
};

const de_de2_plan_build_catalogue_offline = /** @type {(inputs: Plan_Build_Catalogue_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Katalog ist noch nicht auf diesem Gerät. Verbinde dich einmal, um offline zu suchen.`)
};

const it_it2_plan_build_catalogue_offline = /** @type {(inputs: Plan_Build_Catalogue_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il catalogo non è ancora su questo dispositivo. Connettiti una volta per cercare offline.`)
};

/**
* | output |
* | --- |
* | "The catalogue isn't on this device yet. Connect once to search offline." |
*
* @param {Plan_Build_Catalogue_OfflineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_catalogue_offline = /** @type {((inputs?: Plan_Build_Catalogue_OfflineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Catalogue_OfflineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_catalogue_offline(inputs)
	if (locale === "es-419") return es_419_plan_build_catalogue_offline(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_catalogue_offline(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_catalogue_offline(inputs)
	if (locale === "de-DE") return de_de2_plan_build_catalogue_offline(inputs)
	if (locale === "it-IT") return it_it2_plan_build_catalogue_offline(inputs)
	return en_us2_plan_build_catalogue_offline(inputs)
});
export { plan_build_catalogue_offline as "plan-build.catalogue_offline" }